import React from "react";

export default function BlueLoader({ top, width, right, z = 50, bg }) {
  return (
    <>
      <div
        style={{ backgroundColor: `${bg}` }}
        className="absolute opacity-50 h-full w-full flex items-center justify-center rounded-[1.8vw] z-30 "
      ></div>
      <div className="absolute h-full w-full flex items-center justify-center z-40">
        <img
          src="../assets/images/loader/blueloader.svg"
          alt=""
          style={{
            width: `${width}vw`,
            top: `${top}%`,
            right: `${right}%`,
            zIndex: `${z}`,
          }}
          className="opacity-100  "
        />
      </div>
    </>
  );
}
